export default {
    brandingFeatures: {
        logo_url: "vendor_bluearrow-logo",
        app_name_prefix: 'BLUEARROW',
        theme_selection: "light"
    },
    globals: {}
}